import { Grid, Slide, TextField } from '@mui/material';
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system';
import { useRouter } from 'next/router';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadAppView from '../../components/DownloadAppView/DownloadAppView';
import Head from 'next/head';
import { aboutURL } from '../../shared/constants';

const About = () => {
  const router = useRouter();

  const handleGoBackClick = () =>{
    router.back();
  }

  return (
    <>
    <Head>
        <title>About TryTryBuy</title>
        <meta name="description" content="Virtually try on hundreds of your favorite brands before buying. Try on sunglasses, hats, watches, and shoes so you can confidently buy online. " />
    </Head>
    <Slide in={true} direction={"up"}>
    <Grid container direction={"column"}>
      <Grid item>
        <Box px={2} sx={{boxShadow:"0px 4px 0px #000000"}}>
          <Grid container alignItems={"center"} height={70}>
            <Box position={"absolute"} display={"flex"} alignItems={"center"}>
            <ExpandMoreIcon sx={{cursor:"pointer"}} onClick={handleGoBackClick}/>
            </Box>
            <Grid item container justifyContent={"center"}>
            <Typography variant='customBodyStrongCondensed'>About</Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item container pt={{xs:4,md:8}}>
      <Grid item xs={0} sm={0.5} lg={2.5}></Grid>
      <Grid item xs={12} sm={11} lg={7}>
        <DownloadAppView/>
      </Grid>
      <Grid item xs={0} sm={0.5} lg={2.5}></Grid>
      </Grid>
      <Grid item container>
        <Grid item xs={0}  sm={0.5} lg={2.5}></Grid>
        <Grid item xs={12} sm={11} lg={7} container direction={"column"} pt={4}>
          <Grid item>
            {/* TODO: Redirect link will be updated when the domain is set */}
            <a href={aboutURL} target="_blank" style={{
              textDecoration: "inherit",
              color: "inherit",
              cursor: "auto",
            }}>
            <Box px={2.5} py={2}  sx={{borderBottom:"1px solid #c5c5c5", borderTop:"1px solid #c5c5c5", cursor:"pointer"}}>
              <Typography variant='customBody'>About TRYO</Typography>
            </Box>
            </a>
          </Grid>
          <Grid item>
            <Box px={2.5} py={2}  sx={{borderBottom:"1px solid #c5c5c5", cursor:"pointer"}} onClick={()=>{router.push("about/contact-us")}}>
              <Typography variant='customBody'>Contact us</Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box px={2.5} py={2}  sx={{borderBottom:"1px solid #c5c5c5", cursor:"pointer"}} onClick={()=>{router.push("about/privacy-policy")}}>
              <Typography variant='customBody'>Privacy Policy</Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box px={2.5} py={2}  sx={{borderBottom:"1px solid #c5c5c5", cursor:"pointer"}} onClick={()=>{router.push("about/terms-of-use")}}>
              <Typography variant='customBody'>Terms of use</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={0}  sm={0.5} lg={2.5}></Grid>
      </Grid>
    </Grid>
    </Slide>
    </>
  )
}

export default About